module.exports = __webpack_public_path__ + "img/switchTo.eddcce64.svg";